import { render, staticRenderFns } from "./Log.vue?vue&type=template&id=2ba5a016&"
import script from "./Log.vue?vue&type=script&lang=js&"
export * from "./Log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports